import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ChatMessage.css';
import adminIconPng from '../../../images/spackle-icon.png';
import SimpleTruncate from '../text/SimpleTruncate';
import Date from 'components/shared/text/Date';
import ChatAttachments from 'components/shared/chat/ChatAttachments';

class ChatMessage extends Component {
  static propTypes = {
    note: PropTypes.shape({
      content: PropTypes.string,
      created_at: PropTypes.string,
      documents: PropTypes.arrayOf(PropTypes.shape({})),
      images: PropTypes.arrayOf(PropTypes.shape({})),
      user: PropTypes.shape({
        accountable_id: PropTypes.number,
        accountable_type: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      }),
    }).isRequired,
    elapsedTime: PropTypes.shape({
      years: PropTypes.number,
      months: PropTypes.number,
      days: PropTypes.number,
      hours: PropTypes.number,
      minutes: PropTypes.number,
    }),
    linesShown: PropTypes.number,
  };

  static defaultProps = {
    note: {
      content: '',
      created_at: '',
      documents: [],
      images: [],
      user: {
        accountable_id: null,
        accountable_type: '',
        first_name: '',
        last_name: '',
      },
    },
    elapsedTime: null,
    linesShown: 4,
  };

  render() {
    const { note, elapsedTime, linesShown } = this.props;
    const spackle = !note.user.accountable_id && !note.user.accountable_type;
    return (
      <div className="chat-message">
        <div className="note-icon-container">
          {spackle ? (
            <div className="icon with-icon">
              <img src={adminIconPng} alt="user-icon" />
            </div>
          ) : (
            <div className="icon no-icon">
              {note.user.first_name.charAt(0)}
              {note.user.last_name.charAt(0)}
            </div>
          )}
        </div>

        <div className="note-content-container">
          <div className="user-date">
            <span>
              {note.user.first_name} {note.user.last_name}
            </span>
            {elapsedTime ? (
              <span>{this.renderCreatedAt()}</span>
            ) : (
              note.created_at && (
                <Date value={note.created_at} format="MM/DD/YY hh:mm A" />
              )
            )}
          </div>
          <div className="content">
            <SimpleTruncate shownLines={linesShown} text={note.content} />
            <ChatAttachments note={note} />
          </div>
        </div>
      </div>
    );
  }

  renderCreatedAt() {
    const { elapsedTime } = this.props;
    const values = [];
    if (elapsedTime.years > 0) {
      values.push(elapsedTime.years + 'y');
    }
    if (elapsedTime.months > 0) {
      values.push(elapsedTime.months + 'mo');
    }
    // Only show two attributes from the range value
    if (elapsedTime.days > 0 && values.length < 2) {
      values.push(elapsedTime.days + 'd');
    }
    if (elapsedTime.hours > 0 && values.length < 2) {
      values.push(elapsedTime.hours + 'h');
    }
    if (elapsedTime.minutes > 0 && values.length < 2) {
      values.push(elapsedTime.minutes + 'm');
    }

    return values.join(' ');
  }
}

export default ChatMessage;



// WEBPACK FOOTER //
// ./src/components/shared/chat/ChatMessage.js